export const SNIPPETS_CONFIG = {
  RESULT_LIST_TEASER_URL: '/snippets/result-list-teaser-1',
  TIMEOUT: 10000,
} as const;
